import {Form, Modal, ModalBody, ModalHeader} from "reactstrap";
import {I18n} from "../../../I18n/components/player";
import React from "react";
import {SUPER_ADMIN} from "../../../helpers/constants";
import CompanySelectRow from "../../Promoter/CompanySelectRow";
import ModalButtonsRow from "../../Promoter/ModalButtonsRow";
import PlayerFolderSelectRow from "../PlayerFolder/PlayerFolderSelectRow";
import PlayerMediaSelectRow from "./PlayerMediaSelectRow";
import NameInputRow from "../../Promoter/NameInputRow";

const PlayerMediaModal = props => {

    const companiesSelect = props.authority === SUPER_ADMIN
        ? <CompanySelectRow
            lang={props.lang}
            onCompanyChange={props.onInputChange}
            companyId={props.newMedia.companyId}
            companies={props.companies}
            validator={props.validator}
        />
        : null;

    const folderSelect = (
        <PlayerFolderSelectRow
            lang={props.lang}
            companyIdFilter={props.newMedia.companyId}
            onFolderChange={props.onInputChange}
            folderId={props.newMedia.folderId}
            folders={props.folders}
            validator={props.validator}
            required
        />
    )

    const mediaSelect = !props.editMode
        ? (
            <PlayerMediaSelectRow
                lang={props.lang}
                fileName={props.newMedia.file ? props.newMedia.file.name : ''}
                onMediaChange={props.onInputChange}
                validator={props.validator}
            />
        ) : (
            <NameInputRow
                lang={props.lang}
                defaultValue={props.newMedia.name}
                onNameChange={props.onInputChange}
                validator={props.validator}
                required
                autoFocus
            />
        )

    const buttons = (
        <ModalButtonsRow
            lang={props.lang}
            onCancelClick={props.toggle}
            isSaveDisable={props.isSaveDisable}
        />
    )

    return (
        <Modal
            isOpen={props.isModal}
            toggle={props.toggle}
            centered
            autoFocus={!props.editMode}
        >
            <ModalHeader toggle={props.toggle}>
                {I18n[props.lang].modal.addOrEditMedia}
            </ModalHeader>
            <ModalBody>
                <Form onSubmit={props.handleSubmit}>
                    {companiesSelect}
                    {folderSelect}
                    {mediaSelect}
                    {buttons}
                </Form>
            </ModalBody>
        </Modal>
    );
}

export default PlayerMediaModal;


// WEBPACK FOOTER //
// ./src/components/Player/PlayerMedia/PlayerMediaModal.js